import { render, staticRenderFns } from "./TicketVerticalCard.vue?vue&type=template&id=038a69c4"
import script from "./TicketVerticalCard.vue?vue&type=script&lang=js"
export * from "./TicketVerticalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports